export enum StockTakeStatusEnum {
  DRAFT = 0,
  REGISTERED = 1,
}
